import { useState } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Collapse, IconButton, TableCell, TableRow } from '@mui/material';
import { DebentureLiabilitySeries } from 'src/types/operations/debentures';

import OperationDebenturesLiabilityQuotePanel from './OperationDebenturesLiabilityQuotePanel';
import {
  formatLiabilityCurrency,
  formatLiabilityDate,
  formatLiabilityText,
} from '../utils';

interface OperationDebenturesLiabilityQuoteRowProps {
  series: DebentureLiabilitySeries;
}

export default function OperationDebenturesLiabilityQuoteRow({
  series,
}: OperationDebenturesLiabilityQuoteRowProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow
        onClick={() => setOpen((prev) => !prev)}
        sx={{ cursor: 'pointer' }}>
        <TableCell width={36}>
          <IconButton aria-label="expandir linha" size="small" tabIndex={-1}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell sx={{ fontSize: '0.8em' }}>
          {formatLiabilityText(series.classe)}
        </TableCell>
        <TableCell sx={{ fontSize: '0.8em' }}>
          {formatLiabilityText(series.serie)}
        </TableCell>
        <TableCell align="right" sx={{ fontSize: '0.8em' }}>
          {formatLiabilityCurrency(series.valorNominalEmissao)}
        </TableCell>
        <TableCell align="right" sx={{ fontSize: '0.8em' }}>
          {formatLiabilityDate(series.dataReferencia)}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={5} sx={{ py: 0 }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <OperationDebenturesLiabilityQuotePanel series={series} />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
